import RoundedCheck from "@/assets/RoundedCheck";
import { Place } from "@/types";

export default function PlaceSearchItem({
  place,
  selected = false,
  onClick,
}: {
  place: Place;
  selected?: boolean;
  onClick?: () => void;
}) {
  return (
    <div
      data-selected={selected}
      className="flex w-full flex-row items-center rounded-xl p-2 data-[selected='true']:bg-medium-gray/80"
      onClick={onClick}
    >
      <div key={place.id} className="items-left flex w-full flex-col">
        <h1 className="text-lg font-bold">
          {place.name.length > 38 ? place.name.substring(0, 34) + ".." : place.name}
        </h1>
        <p className=" text-sm text-[#e2e8f0]">
          {place.address.length > 38
            ? place.address.substring(0, 36) + ".."
            : place.address}
        </p>
      </div>
      <div>{selected && <RoundedCheck />}</div>
    </div>
  );
}
